/*
 * Copyright (c) 2019. ProVision Media Group Ltd. <https://provision.bg>
 * Venelin Iliev <http://veneliniliev.com>
 */

import { Component, OnInit } from '@angular/core';
import { Router, NavigationEnd, ActivatedRoute } from '@angular/router';
import { Title } from '@angular/platform-browser';
import { TranslateService } from '@ngx-translate/core';
import { queueScheduler, scheduled } from 'rxjs';
import { filter, map, mergeAll, mergeMap } from 'rxjs/operators';

import { environment } from '@env/environment';
import { Logger, I18nService, AuthenticationService } from '@app/core';
import { WebSocketsService } from '@app/core/websockets/websockets.service';
import { NgbModalConfig } from '@ng-bootstrap/ng-bootstrap';
import { TimeTrackingService } from '@app/core/time-tracking/time-tracking.service';
import { PushNotificationService } from '@app/core/push-notifications/push-notifications.service';

const log = new Logger('App');

@Component({
  selector: 'app-root',
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent implements OnInit {
  constructor(
    private router: Router,
    private activatedRoute: ActivatedRoute,
    private titleService: Title,
    private translateService: TranslateService,
    // do not remove the analytics injection, even if the call in ngOnInit() is removed
    // this injection initializes page tracking through the router
    // private angulartics2GoogleAnalytics: Angulartics2GoogleAnalytics,
    private i18nService: I18nService,
    private sockets: WebSocketsService,
    private authenticationService: AuthenticationService,
    modalConfig: NgbModalConfig,
    private timeTracking: TimeTrackingService,
    private pushNotificationService: PushNotificationService
  ) {
    // да не може да се затваря модала при клик извън модала
    modalConfig.backdrop = 'static';
    modalConfig['container'] = '#main-content';
  }

  ngOnInit() {
    // Setup logger
    if (environment.production) {
      Logger.enableProductionMode();
    }

    log.debug('init');

    // this.angulartics2GoogleAnalytics.eventTrack(environment.version, { category: 'App initialized' });

    // Load user profile
    this.authenticationService.loadProfile().subscribe(
      () => {},
      () => {}
    );

    // Setup translations
    this.i18nService.init(environment.defaultLanguage, environment.supportedLanguages);

    const onNavigationEnd = this.router.events.pipe(filter((event) => event instanceof NavigationEnd));

    // Change page title on navigation or language change, based on route data
    // merge(this.translateService.onLangChange, onNavigationEnd)
    scheduled([this.translateService.onLangChange, onNavigationEnd], queueScheduler)
      .pipe(mergeAll())
      .pipe(
        map(() => {
          let route = this.activatedRoute;
          while (route.firstChild) {
            route = route.firstChild;
          }
          return route;
        }),
        filter((route) => route.outlet === 'primary'),
        mergeMap((route) => route.data)
      )
      .subscribe((event) => {
        const title = event['title'];
        if (title) {
          this.titleService.setTitle(this.translateService.instant(title));
        }
      });

    /*
    Connect to websockets on run
     */
    //this.sockets.connect();

    /*
    Time tracking start
    */
    this.timeTracking.start();

    /*
    Notifications request permission
    */
    this.pushNotificationService.requestPermission();
  }
}
